import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldFloor extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'floor');
  }
}
